// extracted by mini-css-extract-plugin
export default {"main":"main--x4S8m","error":"error--fYHYz"};